import { render } from "./CollaborationsView.vue?vue&type=template&id=ba658dce"
import script from "./CollaborationsView.vue?vue&type=script&lang=js"
export * from "./CollaborationsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__